import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout route: hosts the receiving-module sub-pages (fractionation, ...).
export const Route = createFileRoute('/_protected/expedition')({
  component: () => <Outlet />,
})
